import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import axios from "axios";

import { useMsal } from "@azure/msal-react";
import { silentRequest } from "../../../authConfig";

// import * as signalR from "@microsoft/signalr";

import paginate from "jw-paginate";

import { Pagination } from "@fluentui/react-experiments/lib/Pagination";

import CountUp from "react-countup";

import {
    //TextField,
    //DetailsList,
    DetailsListLayoutMode,
    ShimmeredDetailsList,
    Selection,
    SelectionMode,
    //IColumn,
    mergeStyleSets,
    TooltipHost,
    //Fabric,
    ActionButton,
    // Icon,
    //ProgressIndicator,
    //Label,
    Spinner,
    SpinnerSize,
    CommandBar,
    Stack,
    DocumentCard,
    //DocumentCardActivity,
    DocumentCardTitle,
    DocumentCardDetails,
    DocumentCardLogo,
    //DocumentCardStatus,
    DocumentCardType,
    Text,
    DefaultButton,
    ContextualMenu,
    ContextualMenuItemType,
    IconButton,
    CheckboxVisibility,
    FontIcon,
    mergeStyles,
    // Checkbox,
    DatePicker,
    PrimaryButton,
    // Calendar,
    // DateRangeType,
    Pivot,
    PivotItem,
    // Label,
    Link,
    MessageBar,
    MessageBarType,
    DialogType,
    Dialog,
    Dropdown,
    DialogFooter,
    DateRangeType,
    Calendar,
    Checkbox,
    TextField
    //Pagination
    //initializeIcons
} from "@fluentui/react";

import {
    getFileTypeIconProps,
    //FileIconType
} from "@fluentui/react-file-type-icons";

const API_URL = process.env.REACT_APP_API_URL;
const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;

const homeStyles = {
    //width: '208',
    //height: '10vh',
    //width: 185,
    //height: 70,
    //boxSizing: 'border-box',
    //border: '1px solid #eee',
    //overflowY: 'auto',
    //paddingTop: '10vh',
    //background: '#FFFFFF',
    //background: '#106ebe',
    border: 0,
    /* paddingTop: '2%',
    paddingLeft: '2%',
    paddingRight: '2%', */
    margin: 0,
    //minHeight: '100vh',
    width: "100%",
    background: "#FAF9F8",
};

//ProgressIndicator
//const centerItem = { display: "flex", alignItems: "center", justifyContent: "center" };
//Progress Indicator Setting
//const intervalDelay = 100;
//const intervalIncrement = 0.01;

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: "16px",
    },
    fileIconCell: {
        textAlign: "center",
        selectors: {
            "&:before": {
                content: ".",
                display: "inline-block",
                verticalAlign: "middle",
                height: "100%",
                width: "0px",
                visibility: "hidden",
            },
        },
    },
    fileIconImg: {
        verticalAlign: "middle",
        maxHeight: "16px",
        maxWidth: "16px",
    },
    controlWrapper: {
        display: "flex",
        flexWrap: "wrap",
    },
    exampleToggle: {
        display: "inline-block",
        marginBottom: "10px",
        marginRight: "30px",
    },
    selectionDetails: {
        marginBottom: "20px",
    },
});
/* 
const shimmeredDetailsListProps = {
renderedWindowsAhead: 0,
renderedWindowsBehind: 0,
};
*/

const cardStyles = {
    cardStyles: {
        root: {
            background: "white",
            //padding: 20,
            //marginRight: '50%',
            //marginRight: '40px',
            //borderTop: '5px solid #0078d4',
            borderLeft: "5px solid #0078d4",
            width: "30%",
            minWidth: "315px",
            //maxWidth: '415px',
            maxWidth: "424px",
            height: "130px",
            //margin: 'auto',
            //padding: '0 10% 0 10% ',
            //display: 'flex',
            //alignItems: 'center',
            //justifyContent: 'center',
        },
    },
    header: {
        root: {
            fontSize: 20,
            fontWeight: "bold",
            //paddingTop: '5%',
            paddingTop: "20px",
            textAlign: "center",
            //color: '#696969'
        },
    },
    amount: {
        root: {
            fontSize: 30,
            //paddingBottom: 20,
            //paddingBottom: '8%',
            paddingBottom: "25px",
            //paddingTop: '20%',
            //paddingRight: '20%',
            textAlign: "center",
        },
    },
};

const DayPickerStrings = {
    months: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
    ],

    shortMonths: [
        'ม.ค.',
        'ก.พ.',
        'มี.ค.',
        'เม.ย.',
        'พ.ค.',
        'มิ.ย.',
        'ก.ค.',
        'ส.ค.',
        'ก.ย.',
        'ต.ค.',
        'พ.ย.',
        'ธ.ค.',
    ],

    days: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],

    shortDays: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],

    goToToday: 'ไปวันที่ปัจจุบัน',
    prevMonthAriaLabel: 'ไปเดือนที่แล้ว',
    nextMonthAriaLabel: 'ไปเดือนถัดไป',
    prevYearAriaLabel: 'ไปปีที่แล้ว',
    nextYearAriaLabel: 'ไปปีถัดไป',
    closeButtonAriaLabel: 'ปิด',
    monthPickerHeaderAriaLabel: '{0}, เลือกเพื่อเปลี่ยนปี',
    yearPickerHeaderAriaLabel: '{0}, เลือกเพื่อเปลี่ยนเดือน',

    isRequiredErrorMessage:'กรุณาเลือกวันที่',

    invalidInputErrorMessage: 'รูปแบบวันที่ไม่ถูกต้อง',
};

function formatDateTime(date) {
    //let d = new Date(date).toLocaleString("en-GB", {timeZone: "Asia/Bangkok"}),
    let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        hour = "" + d.getHours(),
        minute = "" + d.getMinutes(),
        second = "" + d.getSeconds();

    //console.log(d.toString());

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    if (hour.length < 2) hour = "0" + hour;
    if (minute.length < 2) minute = "0" + minute;
    if (second.length < 2) second = "0" + second;

    return [year, month, day, hour, minute, second].join("");
}

const onFormatDate = (date, format) => {
    if (format === 'CE') {
      return `${date.getDate()}`.padStart(2, '0') + '/' + `${date.getMonth() + 1}`.padStart(2, '0') + '/' + date.getFullYear();
    } else {
      return `${date.getDate()}`.padStart(2, '0') + '/' + `${date.getMonth() + 1}`.padStart(2, '0') + '/' + (date.getFullYear() + 543);
    }
};

const formatDate = (d) => {
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return [year, month, day].join('-');
  };

let monthNames = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];

const Billings = (props) => {
    // console.log("Home render!!!");

    const history = useHistory();
    const location = useLocation();

    const data = location.state;

    // console.log("data", data)

    const { instance, accounts } = useMsal();
    //const account = useAccount(accounts[0] || {});
    const account = instance.getAllAccounts()[0];

    //let token = b2cauth.getAccessToken();
    //console.log('Bearer', token);

    //const token = props.token;
    //const token = props.token;
    //

    //const api_key = props.api_key;
    //console.log('Api-Key:', props.api_key);

    //const items = [];
    const [documents, setDocuments] = useState([]);
    const [items, setItems] = useState([]);
    const [loadDataComplete, setLoadDataComplete] = useState(false);
    const [getNewDocuments, setGetNewDocuments] = useState(true);
    const [totalProcessingDocuments, setTotalProcessingDocuments] = useState(0);
    //const [clickDelete, setClickDelete] = useState(false);
    const [copySuccess, setCopySuccess] = useState(false);

    const [pageData, setPageData] = useState({});
    const [pageSize, setPageSize] = useState(
        sessionStorage.getItem("pageSize") * 1 || 100
    );
    const [currentPage, setCurrentPage] = useState(
        sessionStorage.getItem("currentPage") * 1 || 1
    );
    /* 
    const [pageData, setPageData] = useState({
      totalItems: '',
      currentPage: '',
      pageSize: '',
      totalPages: '',
      startPage: '',
      endPage: '',
      startIndex: '',
      endIndex: '',
      pages: [] 
    });
 */
    //const [percentComplete, setPercentComplete] = useState(0);

    //CommandBars Items
    const [documentType, setDocumentType] = useState(
        (sessionStorage.getItem("documentType-key") && {
            key: sessionStorage.getItem("documentType-key"),
            text: sessionStorage.getItem("documentType-text"),
        }) || {
            key: "ALL",
            text: "เอกสารทุกประเภท",
        }
    );

    const [deletedStatus, setDeletedStatus] = useState(
        (sessionStorage.getItem("deletedStatus-key") && {
            key: sessionStorage.getItem("deletedStatus-key"),
            text: sessionStorage.getItem("deletedStatus-text"),
        }) || { key: "allDeletedStatus", text: "เอกสารทั้งหมด" }
    );

    const [rdStatusType, setRdStatusType] = useState(
        (sessionStorage.getItem("rdStatusType-key") && {
            key: sessionStorage.getItem("rdStatusType-key"),
            text: sessionStorage.getItem("rdStatusType-text"),
        }) || { key: "allRdStatus", text: "สถานะนำส่งทั้งหมด" }
    );

    const [showRepeatNumber, setShowRepeatNumber] = useState(false);
    const [search, setSearch] = useState('');
    const [previousSearch, setPreviousSearch] = useState('');

    const [primarySort, setPrimarySort] = useState(
        sessionStorage.getItem("primarySort") || "createdTime"
    );

    const [sortDirection, setSortDirection] = useState(
        sessionStorage.getItem("sortDirection") || "DESC"
    );

    const [selectPercentWht, setSelectPercentWht] = useState(0);
    const [billingDiscount, setBillingDiscount] = useState(0);

    const [dialogConfirm, setDialogConfirm] = useState({
        isClick: false,
        currentBillingNumber: '',
        currentBillingId: '',
        data: null
    });

    const [dialogCreateReceiptTaxinvoiceConfirm, setDialogCreateReceiptTaxinvoiceConfirm] = useState({
        isClick: false,
        currentBillingNumber: '',
        currentBillingId: '',
        paymentNote: '',
        documentNumber: '',
        documentDate: '',
        transactionDate: '',
        transactionTime: ''
    });

    const getMonth = (goBack) => {
        let monthNames = [
            "มกราคม",
            "กุมภาพันธ์",
            "มีนาคม",
            "เมษายน",
            "พฤษภาคม",
            "มิถุนายน",
            "กรกฎาคม",
            "สิงหาคม",
            "กันยายน",
            "ตุลาคม",
            "พฤศจิกายน",
            "ธันวาคม",
        ];

        let d = new Date();
        //console.log('new Date(): ', d);

        let adjustDate = new Date(d.getFullYear(), d.getMonth() - goBack, 1);

        //d.setMonth(d.getMonth() - goBack);
        //console.log(d.toLocaleDateString());
        //console.log(d.getMonth());

        let year = adjustDate.getFullYear() + 543;

        return {
            month: adjustDate.getMonth(),
            year: adjustDate.getFullYear(),
            key: adjustDate.getMonth() + 1,
            text: monthNames[adjustDate.getMonth()] + " " + year,
        };
        //return monthNames[d.getMonth()] + ' ' + year;
        //let m = d.getMonth();
        /* 
      let d;
      let year;
      let _month = [];
      

      for (let i = 0; i < 6; i++) {
        d = new Date();
        d.setMonth(d.getMonth() - i);
        year = d.getFullYear() + 543;
        _month.push(monthNames[d.getMonth()] + ' ' + year);
      }
*/

        //console.log(_month);

        //return _month;
    };

    const [queryMonth, setQueryMonth] = useState(
        (sessionStorage.getItem("queryMonth-key") && {
        key: sessionStorage.getItem("queryMonth-key"),
        text: sessionStorage.getItem("queryMonth-text"),
        ...(sessionStorage.getItem("queryMonth-type") ? { type: sessionStorage.getItem("queryMonth-type") } : {}),
        }) || { key: getMonth(0).year + '' + getMonth(0).key, text: monthNames[new Date().getMonth()] + ' ' + new Date().getFullYear() + 543 }
    );

    const getFromDMY = (day, month, year) => {
        let _firstDay = new Date(year, month, day);
        console.log('First day: ', formatDate(_firstDay));

        return formatDate(_firstDay);
    };

    const getToDMY = (day, month, year) => {
        let _lastDay = new Date(year, month, day + 1);
        console.log('Last day: ', formatDate(_lastDay));

        return formatDate(_lastDay);
    };

    // const [timeRangeDate, setTimeRangeDate] = useState(false);
    const [fromDate, setFromDate] = useState(
        sessionStorage.getItem('fromDate') ? new Date(sessionStorage.getItem('fromDate')) : new Date()
      );
      const [toDate, setToDate] = useState(sessionStorage.getItem('toDate') ? new Date(sessionStorage.getItem('toDate')) : new Date());
      const [timeRangeError, setTimeRangeError] = useState(false);

      const [timeRangeDate, setTimeRangeDate] = useState(false);

      const getFrom = (month, year) => {
        let _firstDay = new Date(year, month, 1);
        // console.log('First day: ', formatDate(_firstDay));

        return formatDate(_firstDay);
    };

    const getTo = (month, year) => {
        let _lastDay = new Date(year, month + 1, 1);
        // console.log('Last day: ', formatDate(_lastDay));

        return formatDate(_lastDay);
    };
    
      const getFrom2 = (day, month, year) => {
        let _firstDay = new Date(year, month, day);
    
        return Math.floor(_firstDay / 1000);
      };
    
      const getTo2 = (day, month, year) => {
        let _lastDay = new Date(year, month, day + 1);
    
        return Math.floor(_lastDay / 1000);
      };

      const [from, setFrom] = useState(getFrom(getMonth(0).month, getMonth(0).year));
      const [to, setTo] = useState(getTo(getMonth(0).month, getMonth(0).year));
      const [date, setDate] = useState(new Date());

      const [from2, setFrom2] = useState(
        sessionStorage.getItem('from2') || getFrom2(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())
      );
      const [to2, setTo2] = useState(
        sessionStorage.getItem('to2') || getTo2(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())
      );
/* 
    const formatDate = (d) => {
        //let d = new Date(date),
        let month = "" + (d.getMonth() + 1);
        let day = "" + d.getDate();
        let year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
    };
   
 */
    // const [date, setDate] = useState(sessionStorage.getItem('date') ? new Date(sessionStorage.getItem('date')) : new Date());
    

    function convertDateToUTC() {
        var date = new Date();
        var now_utc = Date.UTC(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds()
        );

        return new Date(now_utc).toISOString();
    }

    

    const [isProcessDocument, setIsProcessDocument] = useState(false);
    const [isProcessDocumentComplete, setIsProcessDocumentComplete] =
        useState(false);

    const [selectedItems, setSelectedItems] = useState([]);

    const [selection] = useState(
        new Selection({
            onSelectionChanged: () => {
                console.log("isCreateDocument: ", isProcessDocument);
                console.log(
                    "isCreateDocumentComplete: ",
                    isProcessDocumentComplete
                );
                let _selectedItems = selection.getSelection();

                setSelectedItems(_selectedItems);
            },
        })
    );

    const [pageDropdown, setPageDropdown] = useState([]);
    const [dateType, setDateType] = useState(
        (sessionStorage.getItem("dateType-key") && {
            key: sessionStorage.getItem("dateType-key"),
            text: sessionStorage.getItem("dateType-text"),
        }) || { key: "created", text: "วันที่สร้างเอกสาร" }
    );

    const [companiesFilter, setCompaniesFilter] = useState(
        data?.companyId ? {
                key: data.companyId,
                text: data.companyName,
            } :
            sessionStorage.getItem("companiesFilter-key") ? 
            {
                key: sessionStorage.getItem("companiesFilter-key"),
                text: sessionStorage.getItem("companiesFilter-text"),
            } : 
            {
                key: "allCompanies",
                text: "บริษัททั้งหมด",
            }
    );

    const [companiesFilterItems, setCompaniesFilterItems] = useState([
        {
            key: "allCompanies",
            text: "บริษัททั้งหมด",
            iconProps: { iconName: "CityNext2" },
            onClick: () => {
                console.log("บริษัททั้งหมด");
                setCompaniesFilter({
                    key: "allCompanies",
                    text: "บริษัททั้งหมด",
                });
                sessionStorage.setItem("companiesFilter-key", "allCreatedBy");
                sessionStorage.setItem("companiesFilter-text", "บริษัททั้งหมด");

                setLoadDataComplete(false);
                setItems([]);
                setGetNewDocuments(true);
            },
            //['data-automation-id']: 'newEmailButton', // optional
        },
    ]);

    // const [role, setRole] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);

    const DayPickerStrings = {
        months: [
            "มกราคม",
            "กุมภาพันธ์",
            "มีนาคม",
            "เมษายน",
            "พฤษภาคม",
            "มิถุนายน",
            "กรกฎาคม",
            "สิงหาคม",
            "กันยายน",
            "ตุลาคม",
            "พฤศจิกายน",
            "ธันวาคม",
        ],
    
        shortMonths: [
            'ม.ค.',
            'ก.พ.',
            'มี.ค.',
            'เม.ย.',
            'พ.ค.',
            'มิ.ย.',
            'ก.ค.',
            'ส.ค.',
            'ก.ย.',
            'ต.ค.',
            'พ.ย.',
            'ธ.ค.',
        ],
    
        days: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
    
        shortDays: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
    
        goToToday: 'ไปวันที่ปัจจุบัน',
        prevMonthAriaLabel: 'ไปเดือนที่แล้ว',
        nextMonthAriaLabel: 'ไปเดือนถัดไป',
        prevYearAriaLabel: 'ไปปีที่แล้ว',
        nextYearAriaLabel: 'ไปปีถัดไป',
        closeButtonAriaLabel: 'ปิด',
        monthPickerHeaderAriaLabel: '{0}, เลือกเพื่อเปลี่ยนปี',
        yearPickerHeaderAriaLabel: '{0}, เลือกเพื่อเปลี่ยนเดือน',
    
        isRequiredErrorMessage:'กรุณาเลือกวันที่',
    
        invalidInputErrorMessage: 'รูปแบบวันที่ไม่ถูกต้อง',
      };

    function getDateText(monthObject) {
        if (monthObject.type === 'dateRange') {
            let _splitDate = monthObject.key.split(':');
            let _fromSplit = _splitDate[0].split('-');
            let _toSplit = _splitDate[1].split('-');

                let _from = _fromSplit[2] + '/' + _fromSplit[1] + '/' + (Number(_fromSplit[0]) + 543);
                let _to = _toSplit[2] + '/' + _toSplit[1] + '/' + (Number(_toSplit[0]) + 543);

                return _from + ' - ' + _to;
          
            }

        if (monthObject.text === 'เดือนนี้' || monthObject.text === 'This Month') return 'เดือนนี้';
    
        let monthNames = [
            "มกราคม",
            "กุมภาพันธ์",
            "มีนาคม",
            "เมษายน",
            "พฤษภาคม",
            "มิถุนายน",
            "กรกฎาคม",
            "สิงหาคม",
            "กันยายน",
            "ตุลาคม",
            "พฤศจิกายน",
            "ธันวาคม",
        ];
    
        let _monthIndex = Number(monthObject.key.substring(4, 6)) - 1;
        let _year = Number(monthObject.key.substring(0, 4));
        // if (i18n.language === 'th') {
          _year = _year + 543;
        // }
    
        return monthNames[_monthIndex] + ' ' + _year;
    }

    let commandBarItems = [
        {
            key: deletedStatus.key,
            text: deletedStatus.text,
            cacheKey: "myCacheKey", // changing this key will invalidate this item's cache
            iconProps: { iconName: "Page" },
            disabled: !loadDataComplete || isProcessDocument,
            subMenuProps: {
                items: [
                    {
                        key: "allDeletedStatus",
                        text: "เอกสารทั้งหมด",
                        iconProps: { iconName: "Page" },
                        onClick: () => {
                            console.log("เอกสารทั้งหมด");
                            setDeletedStatus({
                                key: "allDeletedStatus",
                                text: "เอกสารทั้งหมด",
                            });
                            sessionStorage.setItem(
                                "deletedStatus-key",
                                "allDeletedStatus"
                            );
                            sessionStorage.setItem(
                                "deletedStatus-text",
                                "เอกสารทั้งหมด"
                            );

                            setLoadDataComplete(false);
                            setItems([]);
                            setGetNewDocuments(true);

                            setCurrentPage(1);
                        },
                        //['data-automation-id']: 'newEmailButton', // optional
                    },
                    {
                        key: "false",
                        text: "เอกสารที่ไม่ถูกลบ",
                        iconProps: { iconName: "Page" },
                        onClick: () => {
                            console.log("เอกสารที่ไม่ถูกลบ");
                            setDeletedStatus({
                                key: "false",
                                text: "เอกสารที่ไม่ถูกลบ",
                            });
                            sessionStorage.setItem(
                                "deletedStatus-key",
                                "false"
                            );
                            sessionStorage.setItem(
                                "deletedStatus-text",
                                "เอกสารที่ไม่ถูกลบ"
                            );

                            setLoadDataComplete(false);
                            setItems([]);
                            setGetNewDocuments(true);

                            setCurrentPage(1);
                        },
                        //['data-automation-id']: 'newEmailButton', // optional
                    },
                    {
                        key: "true",
                        text: "เอกสารที่ถูกลบ",
                        iconProps: { iconName: "Page" },
                        onClick: () => {
                            console.log("เอกสารที่ถูกลบ");
                            setDeletedStatus({
                                key: "true",
                                text: "เอกสารที่ถูกลบ",
                            });
                            sessionStorage.setItem(
                                "deletedStatus-key",
                                "true"
                            );
                            sessionStorage.setItem(
                                "deletedStatus-text",
                                "เอกสารที่ถูกลบ"
                            );

                            setLoadDataComplete(false);
                            setItems([]);
                            setGetNewDocuments(true);

                            setCurrentPage(1);
                        },
                        //['data-automation-id']: 'newEmailButton', // optional
                    },

                ],
            },
        },
        {
            key: companiesFilter.key,
            text: companiesFilter.text,
            cacheKey: "myCacheKey", // changing this key will invalidate this item's cache
            iconProps: { iconName: "CityNext2" },
            disabled:
                !loadDataComplete ||
                isProcessDocument ||
                companiesFilterItems.length <= 1,
            subMenuProps: {
                items: companiesFilterItems,
            },
        },
        {
            key: dateType.key,
            text: dateType.text,
            cacheKey: "myCacheKey", // changing this key will invalidate this item's cache
            iconProps: { iconName: "CalendarSettings" },
            disabled: !loadDataComplete || isProcessDocument,
            subMenuProps: {
                items: [
                    {
                        key: "created",
                        text: "วันที่สร้างเอกสาร",
                        iconProps: { iconName: "CalendarSettings" },
                        onClick: () => {
                            console.log("วันที่สร้างเอกสาร");
                            setDateType({
                                key: "created",
                                text: "วันที่สร้างเอกสาร",
                            });
                            sessionStorage.setItem("dateType-key", "created");
                            sessionStorage.setItem(
                                "dateType-text",
                                "วันที่สร้างเอกสาร"
                            );

                            sessionStorage.setItem("sortDirection", "DESC");

                            setLoadDataComplete(false);
                            setItems([]);
                            setGetNewDocuments(true);

                            setCurrentPage(1);
                        },
                    },
                    {
                        key: "document",
                        text: "วันที่บนเอกสาร",
                        iconProps: { iconName: "CalendarSettings" },
                        onClick: () => {
                            console.log("วันที่บนเอกสาร");
                            setDateType({
                                key: "document",
                                text: "วันที่บนเอกสาร",
                            });
                            sessionStorage.setItem("dateType-key", "document");
                            sessionStorage.setItem(
                                "dateType-text",
                                "วันที่บนเอกสาร"
                            );

                            sessionStorage.setItem("sortDirection", "DESC");

                            setLoadDataComplete(false);
                            setItems([]);
                            setGetNewDocuments(true);

                            setCurrentPage(1);
                        },
                    },
                ],
            },
        },
        {
            key: queryMonth.key,
            text: getDateText(queryMonth),
            iconProps: { iconName: 'Calendar' },
            disabled: !loadDataComplete || isProcessDocument,
            subMenuProps: {
                items: [
                    {
                        key: 'queryMonth',
                    },
                ],
                onRenderMenuList: () => {
                    return (
                      <div style={{ width: 220 }}>
                        <Stack styles={{ root: { padding: '12px 12px 0px 12px' } }}>
                            <Checkbox
                                label="ช่วงเวลา"
                                checked={timeRangeDate}
                                onChange={(e) => {
                                    setTimeRangeDate((prev) => !prev);
                                }}
                            />
                        </Stack>
                        {timeRangeDate ? (
                            <Stack>
                            <Stack horizontal styles={{ root: { height: 42, paddingTop: 10 } }}>
                                <Stack styles={{ root: { width: '20%', justifyContent: 'center', alignItems: 'center' } }}>
                                    <Text>จาก</Text>
                                </Stack>
                                <Stack styles={{ root: { width: '80%', justifyContent: 'center' /* alignItems: 'center' */ } }}>
                                    <DatePicker
                                        styles={{ root: { width: '90%' } }}
                                        placeholder="กรุณาเลือก"
                                        strings={DayPickerStrings}
                                        value={fromDate}
                                        maxDate={toDate}
                                        formatDate={onFormatDate}
                                        onSelectDate={(_date) => {
                                            setFromDate(_date);

                                            setTimeRangeError(false);
                                            if (Math.ceil(Math.abs(_date - toDate) / (1000 * 60 * 60 * 24)) > 30) setTimeRangeError(true);
                                        }}
                                    />
                                </Stack>
                            </Stack>
                            <Stack horizontal styles={{ root: { height: 42, paddingTop: 10 } }}>
                                <Stack styles={{ root: { width: '20%', justifyContent: 'center', alignItems: 'center' } }}>
                                    <Text>ถึง</Text>
                                </Stack>
                                <Stack styles={{ root: { width: '80%' /* alignItems: 'center' */ } }}>
                                    <DatePicker
                                        styles={{ root: { width: '90%' } }}
                                        placeholder="กรุณาเลือก"
                                        strings={DayPickerStrings}
                                        value={toDate}
                                        minDate={fromDate}
                                        formatDate={onFormatDate}
                                        onSelectDate={(_date) => {
                                            setToDate(_date);

                                            setTimeRangeError(false);
                                            if (Math.ceil(Math.abs(_date - fromDate) / (1000 * 60 * 60 * 24)) > 30) setTimeRangeError(true);
                                        }}
                                    />
                                </Stack>
                            </Stack>
                            {timeRangeError ? (
                                <Stack styles={{ root: { padding: '12px 0px 0px 12px' } }}>
                                <Text styles={{ root: { fontSize: 12, color: '#A4262C' } }}>กรุณาระบุช่วงเวลาไม่เกิน 30 วัน</Text>
                                </Stack>
                            ) : null}
                            <Stack horizontal horizontalAlign="end" styles={{ root: { width: '92%', height: 52, padding: '10px 0px 10px 0px' } }}>
                                <PrimaryButton
                                    text="ค้นหา"
                                    onClick={() => {
                                        if (!timeRangeError && fromDate && toDate) {
                                            setQueryMonth({
                                                type: 'dateRange',
                                                key: formatDate(fromDate) + ':' + formatDate(toDate),
                                                text: formatDate(fromDate) + ' - ' + formatDate(toDate),
                                            });

                                            setFrom(getFromDMY(fromDate.getDate(), fromDate.getMonth(), fromDate.getFullYear()));
                                            setTo(getToDMY(toDate.getDate(), toDate.getMonth(), toDate.getFullYear()));

                                            setLoadDataComplete(false);
                                            setItems([]);
                                            setGetNewDocuments(true);

                                            setCurrentPage(1);
                                        }
                                    }}
                                    style={{ width: '125px', letterSpacing: '1px' }}
                                />
                            </Stack>
                            </Stack>
                        ) : (
                        <Calendar
                            onSelectDate={(_date) => {
                                let monthNames = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];

                                setDate(_date);

                                let adjustDate = _date;

                                let year = adjustDate.getFullYear() + 543;

                                setQueryMonth({
                                    key: adjustDate.getFullYear() + '' + String(adjustDate.getMonth() + 1).padStart(2, '0'),
                                    text: monthNames[adjustDate.getMonth()] + ' ' + year,
                                });

                                setFrom(getFrom(adjustDate.getMonth(), adjustDate.getFullYear()));
                                setTo(getTo(adjustDate.getMonth(), adjustDate.getFullYear()));

                                setLoadDataComplete(false);
                                setItems([]);
                                setGetNewDocuments(true);

                                setCurrentPage(1);
                            }}
                            isMonthPickerVisible={true}
                            highlightSelectedMonth={true}
                            isDayPickerVisible={false}
                            dateRangeType={DateRangeType.Day}
                            autoNavigateOnSelection={false}
                            showGoToToday={false}
                            value={date}
                            strings={DayPickerStrings}
                            showSixWeeksByDefault={true}
                        />
                        )}
                        </div>
                    );
                  },
            },
        },
        {
            key: currentPage,
            text: "หน้า " + currentPage,
            iconProps: { iconName: "Page" },
            disabled: !loadDataComplete || isProcessDocument,
            subMenuProps: {
                items: pageDropdown,
            },
        },
        {
            key: "refresh",
            text: "รีเฟรช",
            iconProps: { iconName: "Refresh" },
            disabled: !loadDataComplete || isProcessDocument,
            onClick: () => {
                console.log("Refresh");

                setLoadDataComplete(false);
                setDocuments([]);
                setItems([]);
                setGetNewDocuments(true);

                setCurrentPage(1);
            },
        },
    ];

    // const [commandBarItems, setCommandBarItems] = useState(_commandBarItems);

    let commandBarItems2 = [
        {
            key: "recreate-pdf",
            text: "สร้าง PDF ใหม่",
            iconProps: { iconName: "RepeatAll" },
            disabled: !loadDataComplete || isProcessDocument || selectedItems.length == 0 || !isAdmin,
            onClick: () => {
                console.log("Recreate PDF");

                console.log("selectionItems: ", selectedItems);

                let confirm = window.confirm("กรุณายืนยัน การสร้างไฟล์ PDF ใหม่, เอกสารที่เลือก จำนวน " + selectedItems.length + " เอกสาร");

                if (confirm && isAdmin) {
                    setIsProcessDocument(true);
                    reCreatePdfSelectedDocuments();

                    
                }
            },
        }
    ];

    const toThaiDateString = (isoDateTime) => {
        let date = "";
        date = new Date(isoDateTime);

        //console.log(dateTime.toLocaleDateString() + ' ' + dateTime.toLocaleTimeString());
        /* 
      let monthNames = [
        "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน",
        "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม.",
        "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
      ];
 */
        let year = date.getFullYear() + 543;
        //let month = monthNames[date.getMonth()];
        let month = (date.getMonth() + 1).toString().padStart(2, "0");
        let numOfDay = date.getDate().toString().padStart(2, "0");

        let hour = date.getHours().toString().padStart(2, "0");
        let minutes = date.getMinutes().toString().padStart(2, "0");
        let second = date.getSeconds().toString().padStart(2, "0");

        return `${numOfDay}/${month}/${year} ${hour}:${minutes}:${second} น.`;
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes";

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return (
            parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
        );
    };

    const initial = async () => {

        await instance.acquireTokenSilent({ ...silentRequest, account: account }).then(async tokenResponse => {
            console.log('tokenResponse: ', tokenResponse);

            await axios.get(ADMIN_API_URL + '/roles',
                {
                    headers: {
                        'Authorization': 'Bearer ' + tokenResponse.accessToken
                    }
                })
                .then((response) => {

                    console.log(response);

                    if (response.data && response.data.roles) {

                        // setRole(response.data.roles);

                        if (response.data.roles === 'admin') {

                            setIsAdmin(true);
                            // console.log('remove array: ', removeByAttr(commandBarItems, 'key', 'delete'));
                        } else {
                            setIsAdmin(false);

                        }

                    } else {
                        history.push({
                            pathname: '/maintenance',
                            state: {},
                        });
                    }

                    // setIsLoadRolesComplete(true);

                }, (error) => {
                    console.log(error);

                });

            axios
                .get(ADMIN_API_URL + '/functions/wakeup', {
                  headers: {
                    Authorization: 'Bearer ' + tokenResponse.accessToken,
                  },
                })
                .then((response) => {
                  console.log('Wake up function: ', response);
                })
                .catch((error) => {
                  console.log(error);
                });

        }).catch(error => {

            //Acquire token silent failure, and send an interactive request
            console.log(error);
            instance.acquireTokenRedirect(silentRequest);

        });

    }

    useEffect(() => {
        console.log("userEffect initial Call!");

        initial();

        //console.log('UTC now: ', convertDateToUTC());
    }, []);

    useEffect(() => {
        console.log("userEffect getNewDocuments Call!");

        if (getNewDocuments) {
            let documentsListEndpoint =
                ADMIN_API_URL +
                // 'http://localhost:7071/api' +
                '/documents/BILLING-NOTE/all?from=' +
                from +
                '&to=' +
                to +
                '&date=' +
                dateType.key +
                '&offset=' +
                (currentPage - 1) * pageSize +
                '&limit=' +
                pageSize +
                '&deleted=' +
                deletedStatus.key + 
                '&companiesId=0be3023f-4e1e-4823-a5de-3d59dcaefbe5&rdStatus=' +
                rdStatusType.key +
                "&sortDirection=" +
                sortDirection +
                "&sortBy=" +
                primarySort;

            let documentsCompaniesNameEndpoint = ADMIN_API_URL + '/companies/name/' + documentType.key + '/all?from=' + from + '&to=' + to + '&date=' + dateType.key + '&search=' + search + '&deleted=' + deletedStatus.key;

            instance
                .acquireTokenSilent({ ...silentRequest, account: account })
                .then(async (tokenResponse) => {
                    const [response, responseCompanies] = await Promise.all([
                        axios
                            .get(documentsListEndpoint, {
                                headers: {
                                    Authorization: 'Bearer ' + tokenResponse.accessToken,
                                },
                            })
                            .catch((error) => console.log(error)),

                        axios.get(documentsCompaniesNameEndpoint, {
                            headers: {
                                Authorization: 'Bearer ' + tokenResponse.accessToken,
                            },
                        }).catch((error) => console.log(error)),
                    ]);

                    let _companiesName = responseCompanies.data;

                    console.log('_companiesName', _companiesName)
                    let _companiesFilterItems = [];
                    if (_companiesName.length > 0) {
                        _companiesFilterItems.push(
                            {
                                key: "allCompanies",
                                text: `บริษัททั้งหมด (${_companiesName.length})`,
                                iconProps: { iconName: "CityNext2" },
                                onClick: () => {
                                    console.log("บริษัททั้งหมด");
                                    setCompaniesFilter({
                                        key: "allCompanies",
                                        text: `บริษัททั้งหมด (${_companiesName.length})`,
                                    });
                                    sessionStorage.setItem(
                                        "companiesFilter-key",
                                        "allCompanies"
                                    );
                                    sessionStorage.setItem(
                                        "companiesFilter-text",
                                        "บริษัททั้งหมด"
                                    );
    
                                    setLoadDataComplete(false);
                                    setItems([]);
                                    setGetNewDocuments(true);
                                },
                                //['data-automation-id']: 'newEmailButton', // optional
                            }
                        );

                        _companiesName = _companiesName.sort((a, b) => {
                            if (a.countTotal > b.countTotal) {
                                return -1;
                            }
                        });

                        _companiesName.forEach((_doc) => {
                            if (!_companiesFilterItems.some(_item => _item.key === _doc.id)) {
                                _companiesFilterItems.push({
                                    key: _doc.id,
                                    text:
                                        _doc.name +
                                        " " +
                                        _doc.branchNumber +
                                        " (" +
                                        _doc.countTotal +
                                        ")",
                                    iconProps: {
                                        iconName: "CityNext2",
                                    },
                                    onClick: () => {
                                        console.log(
                                            _doc.name +
                                                " (" +
                                                _doc.countTotal +
                                                ")"
                                        );
                                        setCompaniesFilter({
                                            key: _doc.id,
                                            text:
                                                _doc.name +
                                                " " +
                                                _doc.branchNumber +
                                                " (" +
                                                _doc.countTotal +
                                                ")",
                                        });
    
                                        sessionStorage.setItem(
                                            "companiesFilter-key",
                                            _doc.id
                                        );
                                        sessionStorage.setItem(
                                            "companiesFilter-text",
                                            _doc.name +
                                            " " +
                                                _doc.branchNumber +
                                                " (" +
                                                _doc.countTotal +
                                                ")"
                                        );
    
                                        setLoadDataComplete(false);
                                        setItems([]);
                                        setGetNewDocuments(true);
    
                                        setCurrentPage(1);
                                    },
                                    //['data-automation-id']: 'newEmailButton', // optional
                                });
                            }
                        });

                        setCompaniesFilterItems(
                            _companiesFilterItems
                        );

                        console.log(
                            "_companiesFilterItems: ",
                            _companiesFilterItems
                        );

                    }

                    // const { countTotal, totalGrand, totalVat } = response.data;

                    // setTotalDocuments(countTotal);
                    // setTotalGrand(totalGrand);
                    // setTotalVat(totalVat);
                        

                    console.log('response pdf', response);

                    let _unfilterDocument = response.data.data.documents;
                    let _totalDocument = response.data.data.countTotal;

                    const _documents = _unfilterDocument.filter(_doc => companiesFilter.key === 'allCompanies' ? true : companiesFilter.key === _doc.data.customer.id);
                    _documents.forEach((doc) => {
                        if (doc.type === 'CREDIT-NOTE') {
                            doc.data.amountTotal = -Math.abs(doc.data.amountTotal);
                            doc.data.grandTotal = -Math.abs(doc.data.grandTotal);
                            doc.data.vatTotal = -Math.abs(doc.data.vatTotal);
                        }
                    });

                    //Page dropdown
                    let _pageDropdown = [];

                    for (let i = 1; i <= Math.ceil(_totalDocument / pageSize); i++) {
                        _pageDropdown.push({
                            key: i,
                            text: 'หน้า ' + i,
                            iconProps: { iconName: 'Page' },
                            onClick: () => {
                                console.log('Selected page: ' + i);
                                setCurrentPage(i);

                                setLoadDataComplete(false);
                                setItems([]);
                                setGetNewDocuments(true);
                            },
                        });
                    }

                    setPageDropdown(_pageDropdown);

                    if (currentPage > Math.ceil(_totalDocument / pageSize)) {
                        setCurrentPage(1);
                    }

                    //set page
                    setPageData(paginate(_totalDocument, currentPage, pageSize, 10));

                    let numberArray = _documents.map(function (doc) {
                        return doc.data.number;
                    });
                    let isDuplicate = numberArray.some(function (number, idx) {
                        return numberArray.indexOf(number) != idx;
                    });

                    setShowRepeatNumber(isDuplicate);

                    let _docs = [];
                    
                    if (_documents.length > 0) {
                        for (let i = 0; i < _documents.length; i++) {
                            let fileSize = formatBytes(_documents[i].file.size);
                            let createdTime = toThaiDateString(_documents[i].createdTime);

                            let _companyEmail = '';

                            let _customerEmail = '';
                            let _customerPhone = '';
                            let _amountTotal = 0;
                            let _vatTotal = 0;
                            let _grandTotal = 0;

                            if (
                                _documents[i].data.company &&
                                _documents[i].data.company.email &&
                                _documents[i].data.company.email !== null &&
                                _documents[i].data.company.email !== undefined
                            ) {
                                _companyEmail = _documents[i].data.company.email;
                            }

                            if (
                                _documents[i].data.customer &&
                                _documents[i].data.customer.email &&
                                _documents[i].data.customer.email !== null &&
                                _documents[i].data.customer.email !== undefined
                            ) {
                                _customerEmail = _documents[i].data.customer.email;
                            }

                            if (
                                _documents[i].data.customer &&
                                _documents[i].data.customer.phone &&
                                _documents[i].data.customer.phone !== null &&
                                _documents[i].data.customer.phone !== undefined
                            ) {
                                _customerPhone = _documents[i].data.customer.phone;
                            }

                            if (_documents[i].type === 'WITHHOLDING-TAX') {
                                _amountTotal = '-';
                                _vatTotal = '-';
                                _grandTotal = '-';
                            } else {
                                if (_documents[i].data.amountTotal) {
                                    _amountTotal = _documents[i].data.amountTotal;
                                }

                                if (_documents[i].data.vatTotal) {
                                    _vatTotal = _documents[i].data.vatTotal;
                                }

                                if (_documents[i].data.grandTotal) {
                                    _grandTotal = _documents[i].data.grandTotal;
                                }
                            }

                            let _isPdfXml = false;

                            if (_documents[i].xmlFile && _documents[i].xmlFile.size) {
                                _isPdfXml = true;
                            }


                            let _rdStatus = "-";

                            if (
                                _documents[i].deliveries.rd.status ===
                                "pending"
                            ) {
                                _rdStatus = "รอส่งอัตโนมัติ";
                            } else if (
                                _documents[i].deliveries.rd.status ===
                                "successful"
                            ) {
                                _rdStatus = "สำเร็จ";
                            } else if (
                                _documents[i].deliveries.rd.status ===
                                "fail"
                            ) {
                                _rdStatus = "ไม่สำเร็จ";
                            }

                            let _documentStatus = _documents[i].data.status;

                            if (_documents[i].data.status === 'open' || _documents[i].data.status === 'new') {
                                if (_documents[i]?.deliveries?.email?.time || _documents[i]?.deliveries?.sms?.response?.date_created) {
                                    _documentStatus = 'sent';
                                }
                            }
                            /* 
                                                        let _deleted = "-";
                            
                                                        if (_documents[i].deleted) {
                                                            _deleted = "ลบ"
                                                        }
                             */
                            _docs.push({
                                key: _documents[i].id,
                                pdfFileName: _documents[i].file.displayName,
                                name: _documents[i].data.name,
                                fileExtension: _documents[i].file.extension,
                                isPdfXml: _isPdfXml,
                                createdBy: _documents[i].createdBy,
                                createdTime: createdTime,
                                createdTimeValue: _documents[i].createdTime,
                                fileSize: fileSize,
                                fileSizeRaw: _documents[i].file.size,
                                type: _documents[i].type,
                                signature: _documents[i].signatures[0].certificateName,
                                product: _documents[i].product,
                                number: _documents[i].data.number,
                                companyEmail: _companyEmail,
                                customerName: _documents[i].data.customer.name,
                                customerEmail: _customerEmail,
                                customerPhone: _customerPhone,
                                amountTotal: _amountTotal,
                                vatTotal: _vatTotal,
                                grandTotal: _grandTotal,
                                data: _documents[i].data,
                                documentDate: _documents[i].data.dateBE,
                                xmlData: _documents[i].xmlFile,
                                rdStatus: _documents[i].deliveries.rd.status,
                                digitalSign: _documents[i].digitalSign,
                                reIssue: _documents[i].data.reIssue,
                                emailReceiver: _documents[i]?.deliveries?.email?.receiver
                                    ? _documents[i].deliveries.email.receiver
                                    : _documents[i].data.customer.email,
                                emailTime: _documents[i]?.deliveries?.email?.time ? toThaiDateString(_documents[i].deliveries.email.time) : '',
                                emailTimeValue: _documents[i]?.deliveries?.email?.time,
                                documentDateValue: _documents[i].data.date,
                                smsTime: _documents[i]?.deliveries?.sms?.response?.date_created
                                    ? toThaiDateString(_documents[i]?.deliveries?.sms?.response?.date_created)
                                    : '',
                                smsTimeValue: _documents[i]?.deliveries?.sms?.response?.date_created,
                                rdStatus: _rdStatus,
                                companyName: _documents[i].data.company.name,
                                deleted: _documents[i].deleted,
                                documentStatus: _documentStatus,
                                receiptTaxInvoiceId: _documents[i].data.receiptTaxInvoiceId
                            });
                        }
                    }

                    console.log('Docs data', _docs);
                    setItems(_docs);

                    setLoadDataComplete(true);
                    setGetNewDocuments(false);
                })
                .catch((error) => {
                    //Acquire token silent failure, and send an interactive request
                    console.log(error);
                    instance.acquireTokenRedirect(silentRequest);
                });


        }
    }, [getNewDocuments]);

    useEffect(() => {
        console.log(
            "isCreateDocumentComplete useEffect: ",
            isProcessDocumentComplete
        );

        if (loadDataComplete && !isProcessDocument) {
            let _items = selection.getItems();
            console.log("_items: ", _items);

            let _selectedItems = selection.getSelection();
            console.log("_selectedItems: ", _selectedItems);

            if (isProcessDocumentComplete) {
                setIsProcessDocumentComplete(false);

                // let _items = selection.getItems();
                //let _keySelected = selection.getSelection()[0].key
                //console.log('_keySelected: ', _keySelected);
                for (let i = 0; i < _items.length; i++) {
                    if (_items[i].status != "") {
                        _items[i].status = "";
                    }
                }
                //selection.setAllSelected(true);
                //selection.setKeySelected(_keySelected, true, true);
                //setItems([...selection.getItems()]);
                // setItems([..._items]);
                //selection.setKeySelected(_keySelected, true, false);
            } else {
                for (let i = 0; i < _items.length; i++) {
                    if (_items[i].status != "") {
                        _items[i].status = "";
                    }
                }

                for (let i = 0; i < _selectedItems.length; i++) {
                    // console.log("select item key: ", _selectedItems[i].key);
                    // _selectedItems[i].status = 'pending';

                    for (let j = 0; j < _items.length; j++) {
                        //console.log('item key: ', _items);
                        if (_items[j].key === _selectedItems[i].key) {
                            // console.log("set pending item key: ", _items[j].key);
                            _items[j].status = "pending";
                            // console.log('_items: ', _items);

                            // _selectedItems[i].status = "pending";
                        }
                        /* else {
                        _items[j].status = "";
                    } */
                    }
                }
            }

            setItems(_items);
        }
    }, [selectedItems]);

    const download = (event, item) => {
        instance
            .acquireTokenSilent({ ...silentRequest, account: account })
            .then((tokenResponse) => {
                let _url = ADMIN_API_URL + "/documents/files/" + item.key;

                if (
                    item.type === "RECEIPT-TAXINVOICE" ||
                    item.type === "RECEIPT-TAXINVOICE-ABB" ||
                    item.type === "RECEIPT" ||
                    item.type === "INVOICE-TAXINVOICE" ||
                    item.type === "DELIVERYORDER-TAXINVOICE" ||
                    item.type === "TAXINVOICE" ||
                    item.type === "DEBIT-NOTE" ||
                    item.type === "CREDIT-NOTE"
                ) {
                    _url = ADMIN_API_URL + "/etax/files/" + item.key;
                }
                //axios.get(API_URL + '/documents/' + item.key, {
                //axios.get(ADMIN_API_URL + '/etax/files/' + item.key, {
                axios
                    .get(_url, {
                        headers: {
                            Authorization:
                                "Bearer " + tokenResponse.accessToken,
                        },
                        responseType: "blob",
                    })
                    .then(
                        (response) => {
                            console.log(response.headers);

                            const time = formatDateTime(item.createdTimeValue);

                            //console.log('item: ', item);

                            let fileName =
                                time +
                                "-" +
                                item.type +
                                "-" +
                                item.number.replace(/\//g, "") +
                                "." +
                                item.fileExtension;

                            console.log("file name: ", fileName);

                            const url = window.URL.createObjectURL(
                                new Blob([response.data])
                            );
                            const link = document.createElement("a");
                            link.href = url;
                            link.setAttribute("download", fileName); //or any other extension
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            })
            .catch((error) => {
                /* 
        if (error instanceof InteractionRequiredAuthError) {
            // fallback to interaction when silent call fails
            return instance.acquireTokenRedirect(tokenRequest)
        }
  */

                //Acquire token silent failure, and send an interactive request
                console.log(error);
                instance.acquireTokenRedirect(silentRequest);

                /* 
        //if (error.errorMessage.indexOf("interaction_required") !== -1) {
        if (error.errorMessage.includes("AADB2C90077")) {
          instance.acquireTokenRedirect(silentRequest);
        }
 */
            });
    };

    const deleteFile = (event, item) => {
        //console.log('Event ', event);
        //token = b2cauth.getAccessToken();
        //b2cauth.run();

        let confirm = window.confirm(
            "กรุณายืนยัน การลบเอกสาร " + item.name + " เลขที่ " + item.number
        );

        if (confirm && isAdmin) {
            instance
                .acquireTokenSilent({ ...silentRequest, account: account })
                .then((tokenResponse) => {
                    //axios.delete(API_URL + '/documents/' + item.key,
                    axios
                        .delete(ADMIN_API_URL + "/etax/documents/" + item.key, {
                            headers: {
                                Authorization:
                                    "Bearer " + tokenResponse.accessToken,
                            },
                        })
                        .then(
                            (response) => {
                                console.log(response);
                                setLoadDataComplete(false);
                                setGetNewDocuments(true);
                            },
                            (error) => {
                                console.log(error);
                            }
                        );
                })
                .catch((error) => {
                    /* 
                if (error instanceof InteractionRequiredAuthError) {
                    // fallback to interaction when silent call fails
                    return instance.acquireTokenRedirect(tokenRequest)
                }
        */

                    //Acquire token silent failure, and send an interactive request
                    console.log(error);
                    instance.acquireTokenRedirect(silentRequest);
                    /* 
                //if (error.errorMessage.indexOf("interaction_required") !== -1) {
                if (error.errorMessage.includes("AADB2C90077")) {
                instance.acquireTokenRedirect(silentRequest);
                }
        */
                });
        }
    };

    const openFile = (event, item) => {
        if (item.fileExtension === "pdf") {
            openFilePdf(event, item);
        }
    };

    const downloadReceiptTaxinvoice = (event, item) => {
        instance.acquireTokenSilent({...silentRequest, account: account}).then(tokenResponse => {
            axios.get(ADMIN_API_URL + '/etax/files/' + item.receiptTaxInvoiceId, 
            {
                headers: { 
                    'Authorization': 'Bearer ' + tokenResponse.accessToken
                },
                responseType: 'blob'
            })
            .then((response) => {
                console.log("response download receipt taxinvoice", response)              
                
                const url = window.URL.createObjectURL(response.data);

                let time = formatDateTime(new Date());

                let fileName = `${time}-RECEIPT-TAXINVOICE.pdf`;

                let link = document.createElement('a');
                link.href = url;
                //link.setAttribute('download', item.fileName); //or any other extension
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                
            }, (error) => {
                console.log(error);
            });

        }).catch(error => {           
            //Acquire token silent failure, and send an interactive request
            console.log(error);
            instance.acquireTokenRedirect(silentRequest);  
        });  

        // history.push({
        //     pathname: "/etax/documents/pdf/view",
        //     state: {
        //         item: {
        //             key: item.receiptTaxInvoiceId
        //         },
        //         //documentId: item.key,
        //         //certificateName: item.signature
        //     },
        // });
    };

    const openFilePdf = (event, item) => {
        history.push({
            pathname: "/etax/documents/pdf/view",
            state: {
                item: item,
                //documentId: item.key,
                //certificateName: item.signature
            },
        });
    };

    const onPageChange = (selectedPageIndex) => {
        console.log("selectedPageIndex: ", selectedPageIndex);
        setCurrentPage(selectedPageIndex + 1);
        setGetNewDocuments(true);
        setLoadDataComplete(false);
    };

    const reCreateBilling = (event) => {
        setDialogConfirm(prev => ({...prev, isClick: false}))

        instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
            axios
                .post(
                    `${ADMIN_API_URL}/documents/billings/recreate`,
                    // `http://localhost:7071/api/documents/billings/recreate`,
                    {
                        currentBillingId: dialogConfirm.currentBillingId,
                        percentWht: selectPercentWht,
                        billingDiscount: billingDiscount,
                        data: dialogConfirm.data
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + tokenResponse.accessToken,
                        },
                    }
                )
                .then(
                    (response) => {
                        console.log("Finish create billing");
                        // setGetNewDocuments(true);

                        setLoadDataComplete(false);
                        setItems([]);
                        setGetNewDocuments(true);
                    },
                    (error) => {
                        console.log(error);
                    }
                );
        })
        .catch((error) => {
            //Acquire token silent failure, and send an interactive request
            console.log(error);
            instance.acquireTokenRedirect(silentRequest);
        });
        
    };

    const createReceiptTaxinvoice = (event) => {
        setDialogCreateReceiptTaxinvoiceConfirm(prev => ({...prev, isClick: false}))

        let _transactionDateTime = '';

        const _date = dialogCreateReceiptTaxinvoiceConfirm.transactionDate ? new Date(dialogCreateReceiptTaxinvoiceConfirm.transactionDate) : new Date();
        _transactionDateTime = `${_date.getFullYear()}${String(_date.getMonth() + 1).padStart(2, "0")}${String(_date.getDate()).padStart(2, "0")}${dialogCreateReceiptTaxinvoiceConfirm.transactionTime.padEnd(6, "0")}`

        console.log("payload: ", {
            currentBillingId: dialogCreateReceiptTaxinvoiceConfirm.currentBillingId,
            paymentNote: dialogCreateReceiptTaxinvoiceConfirm.paymentNote,
            documentNumber: dialogCreateReceiptTaxinvoiceConfirm.documentNumber,
            documentDate: dialogCreateReceiptTaxinvoiceConfirm.documentDate ? new Date(dialogCreateReceiptTaxinvoiceConfirm.documentDate).toISOString() : new Date().toISOString(),
            transactionDateTime: _transactionDateTime
        })

        instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
            axios
                .post(
                    `${ADMIN_API_URL}/documents/billings/create-receipt-taxinvoice`,
                    // `http://localhost:7071/api/documents/billings/create-receipt-taxinvoice`,
                    {
                        currentBillingId: dialogCreateReceiptTaxinvoiceConfirm.currentBillingId,
                        paymentNote: dialogCreateReceiptTaxinvoiceConfirm.paymentNote,
                        documentNumber: dialogCreateReceiptTaxinvoiceConfirm.documentNumber,
                        documentDate: dialogCreateReceiptTaxinvoiceConfirm.documentDate ? new Date(dialogCreateReceiptTaxinvoiceConfirm.documentDate).toISOString() : new Date().toISOString(),
                        transactionDateTime: _transactionDateTime
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + tokenResponse.accessToken,
                        },
                    }
                )
                .then(
                    (response) => {
                        console.log("response create receipt:", response);
                        // setGetNewDocuments(true);

                        setLoadDataComplete(false);
                        setItems([]);
                        setGetNewDocuments(true);
                    },
                    (error) => {
                        console.log(error);
                    }
                );
        })
        .catch((error) => {
            //Acquire token silent failure, and send an interactive request
            console.log(error);
            instance.acquireTokenRedirect(silentRequest);
        });
        
    };

    const reCreatePdfSelectedDocuments = async () => {
        let _items = selection.getItems();

        await instance
            .acquireTokenSilent({ ...silentRequest, account: account })
            .then(async (tokenResponse) => {
                for (let i = 0; i < selectedItems.length; i++) {
                    console.log("Recreate PDF selected document: ", selectedItems[i]);

                    // setUploadingDocumentId(selectedItems[i].key);
                    // setUploadingDocumentNumber(selectedItems[i].number);
                    // setUploadingDocumentStatus("กำลังสร้างไฟล์ PDF ใหม่...");

                    console.log('กำลังสร้างไฟล์ PDF ใหม่...');
/* 
                    if (uploadingXmlStop.current) {
                        uploadingXmlStop.current = false;
                        return;
                    }
 */
                    if (selectedItems[i].rdStatus === 'นำส่งสำเร็จ') {
                        console.log('Already uploaded xml, document id: ', selectedItems[i].key);
                        break;
                    }

                    for (let j = 0; j < _items.length; j++) {
                        //console.log('item key: ', _items);
                        if (_items[j].key === selectedItems[i].key) {
                            console.log("item key: ", _items[j].key);
                            _items[j].status = "processing";
                            //_selectedItems[i].status = "pending";
                            //setItems([]);
                            //_items.sort();
                            console.log("items: ", _items);
                            setItems([..._items]);
                            /* 
                        await new Promise(resolve => {                        
                            setTimeout(resolve, 1500)                        
                        });
    */

                            console.log("item: ", _items[j]);
                            // let detail = await getInvoiceDetail(_items[j].number);

                            const promiseReCreatePdf = await new Promise(async (resolve) => {
                                axios
                                    .post(
                                        ADMIN_API_URL + "/etax/pdf-recreate/" + _items[j].key,
                                        {},
                                        {
                                            headers: {
                                                Authorization: "Bearer " + tokenResponse.accessToken,
                                            },
                                        }
                                    )
                                    .then(
                                        async (response) => {
                                            console.log("Finish reCreatePdfFile " + _items[j].number + ": ", response);

                                            let count = 0;

                                            let interval = await setInterval(async () => {
                                                count += 1;

                                                console.log('count: ', count);

                                                if (response.data && response.data.statusCode == 200) {
                                                    _items[j].status = "successful";
                                                    // _items[j].rdStatus = "นำส่งสำเร็จ";
                                                    
                                                    // _items[j].status = "recreate-xml-success";

                                                    // _items[j].rdDeliveredTime = toThaiDateString(moment(response.data?.data[0]?.sendgwdate).toISOString());
                                                    // _items[j].rdDeliveredTimeValue = response.data?.data[0]?.sendgwdate;
                                                    // _items[j].rdRefNumber = response.data?.data[0]?.refno;
                                                    // _items[j].rdStatusResponse = "สำเร็จ";


                                                    setItems([..._items]);

                                                    clearInterval(interval);

                                                    console.log("สร้างไฟล์ Pdf สำเร็จ");

                                                    // setUploadingDocumentMessage(response.data.message);

                                                    // setUploadingDocumentFileName(response.data?.data[0]?.filename);

                                                    // setUploadingDocumentRefNo(response.data?.data[0]?.refno);

                                                    resolve(true);
                                                } else if (count === 3) {
                                                    // array[i].status = 'ไม่สำเร็จ';
                                                    // _items[j].rdStatus = "นำส่งไม่สำเร็จ";
                                                    _items[j].status = "fail";

                                                    // _items[j].rdStatusResponse = "ไม่สำเร็จ";

                                                    setItems([..._items]);

                                                    clearInterval(interval);

                                                    console.log("สร้างไฟล์ Pdf ไม่สำเร็จ");

                                                    if (response.data?.message) {
                                                        console.log('Recreate Pdf fail message: ', response.data.message);
                                                        // setUploadingDocumentMessage(response.data.message);
                                                    } else {
                                                        // setUploadingDocumentMessage('');

                                                    }

                                                    // setUploadingDocumentFileName("");

                                                    // setUploadingDocumentRefNo("");

                                                    resolve(false);
                                                }
                                            }, 1000);

                                        },
                                        (error) => {
                                            console.log(error);

                                            _items[j].status = "fail";
                                            setItems([..._items]);
                                            resolve(false);
                                        }
                                
                                    );
                            }); //promise

                            Promise.all([promiseReCreatePdf]).then((value) => {
                                console.log(i, value);
                            });
                        } //if
                    } //for j
                } //for i
            })
            .catch((error) => {
                //Acquire token silent failure, and send an interactive request
                console.log(error);
                //instance.acquireTokenRedirect(silentRequest);
            });

        setIsProcessDocumentComplete(true);
        setIsProcessDocument(false);
    };

    const columns = [
        {
            key: "column1",
            name: "วันที่สร้าง",
            fieldName: "createdTime",
            minWidth: 70,
            maxWidth: 125,
            isRowHeader: true,
            isResizable: true,
            data: "string",
            onRender: (item) => {
                if (item.deleted) {
                    return <span style={{ color: '#a4262c'}}>{item.createdTime}</span>;
                }
                return <span>{item.createdTime}</span>;
            },
            // isPadded: true,
        },
        {
            key: "column2",
            name: "เลขที่",
            fieldName: "number",
            minWidth: 80,
            maxWidth: 150,
            isRowHeader: true,
            isResizable: true,
            data: "string",
            onRender: (item) => {
                return <Link onClick={() => {
                    navigator.clipboard.writeText(item.key);
                    setCopySuccess(true);
                    window.scrollTo(0, 0);
                }}>{item.deleted 
                    ? <span style={{ color: '#a4262c'}} data-selection-disabled={true}>{item.number}</span>
                    : <span data-selection-disabled={true}>{item.number}</span>}</Link>;
            },
            // isPadded: true,
        },
        {
            key: "column3",
            name: "วันที่บนเอกสาร",
            fieldName: "documentDate",
            minWidth: 70,
            maxWidth: 70,
            isRowHeader: true,
            isResizable: true,
            data: "string",
            onRender: (item) => {
                return (
                    <TooltipHost content={item.documentDate}>
                        {item.deleted
                            ?
                                <span style={{ color: '#a4262c'}}>{item.documentDate}</span>
                            :
                                <span>{item.documentDate}</span>
                        }
                    </TooltipHost>
                );
            },
            //isPadded: true,
        },
        {
            key: "column4",
            name: "ผู้ซื้อ",
            fieldName: "customerName",
            minWidth: 80,
            maxWidth: 250,
            // isRowHeader: true,
            isResizable: true,
            data: "string",
            onRender: (item) => {
                return (
                    <TooltipHost content={item.customerName}>
                        {item.deleted
                            ?
                                <span style={{ color: '#a4262c'}}>{item.customerName}</span>
                            :
                                item.customerName
                        }
                    </TooltipHost>
                );
            },
            // isPadded: true,
        },
        {
            key: "column5",
            name: "สาขา",
            fieldName: "branchNumber",
            minWidth: 80,
            maxWidth: 250,
            // isRowHeader: true,
            isResizable: true,
            data: "string",
            onRender: (item) => {
                return (
                    <TooltipHost content={item.data.customer.branchNumber}>
                        {item.deleted
                            ?
                                <span style={{ color: '#a4262c'}}>{item.data.customer.branchNumber}</span>
                            :
                                item.data.customer.branchNumber
                        }
                    </TooltipHost>
                );
            },
            // isPadded: true,
        },
        {
            key: "column6",
            name: "ยอดที่ต้องชำระ",
            fieldName: "paidTotal",
            minWidth: 70,
            maxWidth: 70,
            isRowHeader: true,
            data: "number",
            onRender: (item) => {
                if (item.deleted) {

                    return (
                        <span style={{ display: "block", textAlign: "right", color: '#a4262c'}}>
                            {item.data.paidTotal.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                            })}
                        </span>
                    );

                }

                return (
                    <span style={{ display: "block", textAlign: "right" }}>
                        {item.data.paidTotal.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                        })}
                    </span>
                );
            },
            // isPadded: true,
        },
        {
            key: "column7",
            name: "ใบเสร็จรับเงิน",
            fieldName: "receiptTaxInvoiceId",
            minWidth: 70,
            maxWidth: 70,
            isRowHeader: true,
            data: "number",
            onRender: (item) => {
                if (item.receiptTaxInvoiceId) {
                    return (
                        <>
                            <IconButton
                                onClick={(event) => {
                                    downloadReceiptTaxinvoice(event, item);
                                }}
                                iconProps={{
                                    ...getFileTypeIconProps({
                                        extension: item.fileExtension,
                                        size: 32,
                                        imageFileType: "svg",
                                    }),
                                }}
                            />
                        </>
                    )
                }
            },
            // isPadded: true,
        },
        {
            key: 'column8',
            name: 'สถานะ',
            fieldName: 'documentStatus',
            minWidth: 80,
            maxWidth: 80,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            onRender: (item) => {
                let _docStatusText = 'ฉบับร่าง';
                let _styleProp = {};

                if (item.documentStatus === 'draft') _docStatusText = 'ฉบับร่าง';
                if (item.documentStatus === 'open') {
                _docStatusText = 'เปิด';
                _styleProp = { color: '#106EBE' };
                }
                if (item.documentStatus === 'sent') {
                _docStatusText = 'ส่งแล้ว';
                _styleProp = { color: '#106EBE' };
                }
                if (item.documentStatus === 'partial-paid') {
                _docStatusText = 'จ่ายบางส่วน';
                _styleProp = { color: 'green' };
                }
                if (item.documentStatus === 'paid') {
                _docStatusText = 'จ่ายแล้ว';
                _styleProp = { color: 'green' };
                }
                if (item.documentStatus === 'void') {
                _docStatusText = 'ยกเลิก';
                // _styleProp = { color: 'gray' };
                }
                if (item.documentStatus === 'uncollectible') {
                _docStatusText = 'เก็บเงินไม่ได้';
                _styleProp = { color: 'red' };
                }
                if (item.documentStatus === 'fail') {
                _docStatusText = 'ไม่สำเร็จ';
                _styleProp = { color: 'red' };
                }

                if (item.documentStatus === 'processing') {
                return <Spinner label='กำลังดำเนินการ...' labelPosition="right" style={{ marginLeft: '0px' }} />;
                }
                return <span style={_styleProp}>{_docStatusText}</span>;
            },
        },
        {
            key: "column11",
            name: "ไฟล์",
            // className: classNames.fileIconCell,
            // iconClassName: classNames.fileIconHeaderIcon,
            // ariaLabel: 'Column operations for File type, Press to sort on File type',
            // iconName: 'Page',
            // isIconOnly: true,
            fieldName: "name",
            minWidth: 70,
            maxWidth: 70,
            onColumnClick: "",

            onRender: (item) => (
                <>
                    <IconButton
                        onClick={(event) => {
                            openFile(event, item);
                        }}
                        iconProps={{
                            ...getFileTypeIconProps({
                                extension: item.fileExtension,
                                size: 32,
                                imageFileType: "svg",
                            }),
                        }}
                    />
                </>
            ),
        },
        {
            key: "column12",
            name: "",
            fieldName: "command",
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
            //isCollapsible: true,
            data: "string",
            onColumnClick: "",
            onRender: (item) => {
                
                return (
                    <span data-selection-disabled={true}>
                        {isAdmin
                            ?
                            <DefaultButton
                                text="เลือก"
                                //iconProps={{ iconName: 'Add' }}
                                menuProps={{
                                    items: [
                                        {
                                            key: "open",
                                            text: "เปิดเอกสาร",
                                            iconProps: { iconName: "OpenFile" },
                                            onClick: (event) => {
                                                openFile(event, item);
                                            },
                                        },
                                        {
                                            key: "download",
                                            text: "ดาวน์โหลด",
                                            iconProps: {
                                                iconName: "DownloadDocument",
                                            },
                                            onClick: (event) => {
                                                download(event, item);
                                            },
                                        },
                                        {
                                            key: "create",
                                            text: "สร้างใบแจ้งค่าบริการใหม่",
                                            iconProps: {
                                                iconName: "RepeatAll",
                                            },
                                            onClick: (event) => {
                                                setDialogConfirm(prev => ({
                                                    ...prev, 
                                                    isClick: true,
                                                    currentBillingNumber: item.number,
                                                    currentBillingId: item.key,
                                                    data: item.data
                                                }))
                                                // reCreatePdfFile(event, item);
                                            },
                                        },
                                        {
                                            key: "create-receipt-taxinvoice",
                                            text: "สร้างใบเสร็จรับเงิน",
                                            iconProps: {
                                                iconName: "RepeatAll",
                                            },
                                            onClick: (event) => {
                                                setDialogCreateReceiptTaxinvoiceConfirm(prev => ({
                                                    ...prev, 
                                                    isClick: true,
                                                    currentBillingNumber: item.number,
                                                    currentBillingId: item.key,
                                                    documentNumber: "",
                                                    documentDate: "",
                                                    paymentNote: "",
                                                    transactionDate: "",
                                                    transactionTime: ""
                                                }))
                                                // reCreatePdfFile(event, item);
                                            },
                                        },
                                        {
                                            key: "divider_1",
                                            itemType:
                                                ContextualMenuItemType.Divider,
                                        },
                                        {
                                            key: "delete",
                                            text: "ลบ",
                                            iconProps: { iconName: "Delete" },
                                            // disabled: true,
                                            onClick: (event) => {
                                                deleteFile(event, item);
                                            },
                                        },

                                    ],
                                    shouldFocusOnMount: true,
                                    directionalHintFixed: true,
                                }}
                                // Optional callback to customize menu rendering
                                menuAs={(props) => (
                                    <ContextualMenu {...props} />
                                )}
                            />
                            :
                            <DefaultButton
                                text="เลือก"
                                //iconProps={{ iconName: 'Add' }}
                                menuProps={{
                                    items: [
                                        {
                                            key: "open",
                                            text: "เปิดเอกสาร",
                                            iconProps: { iconName: "OpenFile" },
                                            onClick: (event) => {
                                                openFile(event, item);
                                            },
                                        },
                                        {
                                            key: "download",
                                            text: "ดาวน์โหลด",
                                            iconProps: {
                                                iconName: "DownloadDocument",
                                            },
                                            onClick: (event) => {
                                                download(event, item);
                                            },
                                        },
                                    ],
                                    shouldFocusOnMount: true,
                                    directionalHintFixed: true,
                                }}
                                // Optional callback to customize menu rendering
                                menuAs={(props) => (
                                    <ContextualMenu {...props} />
                                )}
                            />
                        }
                    </span>
                );
                
            },
        },
    ];

    const isCompactMode = false;
    //const isModealSelection = false;
    //const annoucedMessage = undefined;

    return (
        <div style={homeStyles}>
            <Stack>
                {copySuccess && 
                    
                    <MessageBar
                        
                        messageBarType={MessageBarType.success}
                        isMultiline={false}
                        onDismiss={() => {setCopySuccess(false)}}
                    >
                        Copy สำเร็จ!               
                    </MessageBar>
                }
                <center>
                    <h2 style={{ marginLeft: "0px", marginTop: "25px" }}>
                        ใบแจ้งค่าบริการทั้งหมด
                    </h2>
                    {/* <h4>( สำหรับส่งให้กรมสรรพากร )</h4> */}
                    {/* <br/> */}
                </center>

                
            </Stack>

            {totalProcessingDocuments > 0 && (
                <div>
                    {/* <Label>Spinner with label positioned below</Label> */}
                    <br />
                    <Spinner
                        label="กำลังสร้างเอกสารและลงลายเซ็นดิจิทัล..."
                        size={SpinnerSize.large}
                    />
                </div>
            )}
            <br />
            {/* <Fabric> */}
            <Stack horizontal horizontalAlign="center">
                <Stack
                    vertical
                    style={{
                        width: "98%",
                        //minWidth: '1070px',
                        maxWidth: "1350px",
                    }}
                >
                    <CommandBar
                        items={commandBarItems}
                    />
                    
                    <ShimmeredDetailsList
                        items={items || []}
                        enableShimmer={!loadDataComplete}
                        compact={isCompactMode}
                        columns={columns}
                        // selectionMode={SelectionMode.none}
                        //selectionMode={SelectionMode.multiple}
                        selection={selection}
                        // selectionMode={SelectionMode.none}
                        selectionMode={
                            !loadDataComplete || isProcessDocument || !isAdmin
                                ? SelectionMode.none
                                : SelectionMode.multiple
                        }
                        //getKey="1"
                        //setKey="set"
                        layoutMode={DetailsListLayoutMode.justified}
                        isHeaderVisible={true}
                        checkboxVisibility={CheckboxVisibility.always}
                        //selection={Selection}
                        selectionPreservedOnEmptyClick={true}
                    />
                </Stack>
            </Stack>
            {/* </Fabric> */}
            <br />
            <center>
                {/* {!(documents.length === 0 || documents.length < pageSize) && */
                    loadDataComplete && (
                        <Pagination
                            //selectedPageIndex={page}
                            selectedPageIndex={currentPage - 1}
                            //pageCount={pageCount}
                            pageCount={pageData.totalPages}
                            onPageChange={onPageChange}
                            format
                            firstPageIconProps={{
                                iconName: "DoubleChevronLeft",
                            }}
                            previousPageIconProps={{ iconName: "ChevronLeft" }}
                            nextPageIconProps={{ iconName: "ChevronRight" }}
                            lastPageIconProps={{
                                iconName: "DoubleChevronRight",
                            }}
                        />
                    )}

                <br />
                <br />
            </center>
            <Dialog
                hidden={!dialogConfirm.isClick}
                dialogContentProps={{
                    type: DialogType.largeHeader,
                    title: "สร้างใบแจ้งค่าบริการใหม่",
                    styles: { header: { textAlign: 'center' }, title: { paddingRight: 24 } },
                    // subText: documentStatusSubText(),
                }}
                >
                <Stack>
                    ยืนยันที่จำออกใบแจ้งค่าบริการ {dialogConfirm.currentBillingNumber} หรือไม่
                </Stack>
                <Stack tokens={{ childrenGap: '20 0' }}>
                    <Dropdown
                        // placeholder="Select an option"
                        label="อัตราภาษีหัก ณ ที่จ่าย:"
                        // style={{ width: "150px" }}
                        styles={{
                            dropdown: { width: 250 },
                        }}
                        options={[
                            { key: 0, text: '-' },
                            { key: 1, text: '1' },
                            { key: 3, text: '3' },
                        ]}
                        selectedKey={selectPercentWht}
                        // styles={dropdownStyles}
                        onChange={(e, selectedOption) => {
                            console.log(selectedOption);
                            setSelectPercentWht(selectedOption.key);
                        }}
                    />
                    <TextField 
                        label="ส่วนลดใบแจ้งค่าบริการ" 
                        type="number"
                        value={billingDiscount}
                        onChange={(e) => setBillingDiscount(e.target.value)}
                    />
                </Stack>

                <DialogFooter styles={{ actionsRight: { textAlign: 'center' } }}>
                    <PrimaryButton text="ยืนยัน" onClick={(e) => reCreateBilling(e)} />
                    <DefaultButton text="ยกเลิก" onClick={() => setDialogConfirm(prev => ({...prev, isClick: false}))} />
                </DialogFooter>
                
            </Dialog>
            <Dialog
                hidden={!dialogCreateReceiptTaxinvoiceConfirm.isClick}
                dialogContentProps={{
                    type: DialogType.largeHeader,
                    title: "สร้างใบเสร็จรับเงิน",
                    styles: { header: { textAlign: 'center' }, title: { paddingRight: 24 } },
                    // subText: documentStatusSubText(),
                }}
                >
                <Stack>
                    <TextField 
                        label="เลขที่บนเอกสาร" 
                        value={dialogCreateReceiptTaxinvoiceConfirm.documentNumber}
                        onChange={(e) => setDialogCreateReceiptTaxinvoiceConfirm(prev => ({...prev, documentNumber: e.target.value}))}
                        description="หากไม่ระบุ จะใช้เลขที่รันอัตโนมัติ"
                    />
                    <div>
                        <DatePicker
                            label="วันที่บนเอกสาร"
                            placeholder="เลือกวันที่"
                            strings={DayPickerStrings}
                            formatDate={onFormatDate}
                            value={dialogCreateReceiptTaxinvoiceConfirm.documentDate}
                            onSelectDate={(date) => setDialogCreateReceiptTaxinvoiceConfirm(prev => ({...prev, documentDate: date}))}
                        />
                        <label style={{ fontSize: 10 }}>หากไม่ระบุ จะใช้วันที่บนเอกสารเป็นวันนี้</label>
                    </div>
                    <div>
                        <DatePicker
                            label="วันที่ชำระ"
                            placeholder="เลือกวันที่"
                            strings={DayPickerStrings}
                            formatDate={onFormatDate}
                            value={dialogCreateReceiptTaxinvoiceConfirm.transactionDate}
                            onSelectDate={(date) => setDialogCreateReceiptTaxinvoiceConfirm(prev => ({...prev, transactionDate: date}))}
                        />
                        <label style={{ fontSize: 10 }}>หากไม่ระบุ จะใช้วันที่ชำระเป็นวันนี้</label>
                    </div>
                    <TextField 
                        label="เวลา" 
                        maxLength={6}
                        value={dialogCreateReceiptTaxinvoiceConfirm.transactionTime}
                        onChange={(e) => setDialogCreateReceiptTaxinvoiceConfirm(prev => ({...prev, transactionTime: e.target.value}))}
                        description="รูปแบบเป็น hhmmss เช่น 123030"
                    />
                    <TextField 
                        label="หมายเหตุการชำระเงิน" 
                        value={dialogCreateReceiptTaxinvoiceConfirm.paymentNote}
                        onChange={(e) => setDialogCreateReceiptTaxinvoiceConfirm(prev => ({...prev, paymentNote: e.target.value}))}
                    />
                </Stack>

                <DialogFooter styles={{ actionsRight: { textAlign: 'center' } }}>
                    <PrimaryButton text="ยืนยัน" onClick={(e) => createReceiptTaxinvoice(e)} />
                    <DefaultButton text="ยกเลิก" onClick={() => setDialogCreateReceiptTaxinvoiceConfirm(prev => ({...prev, isClick: false}))} />
                </DialogFooter>
                
            </Dialog>
        </div>
    );
};

export default Billings;
